import { render } from "./all-course.vue?vue&type=template&id=0088279e&scoped=true"
import script from "./all-course.vue?vue&type=script&lang=js"
export * from "./all-course.vue?vue&type=script&lang=js"

import "./all-course.vue?vue&type=style&index=0&id=0088279e&lang=scss&scoped=true"

import exportComponent from "F:\\my-work\\company\\yuanxi\\yuanxi-csspw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0088279e"]])

export default __exports__